import React, { useContext, useEffect, useState } from "react";

// @material-ui/core components
import { IconButton, InputAdornment } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import { makeStyles } from "@material-ui/core/styles";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import { withRouter } from "react-router";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import { LoginContext } from "contexts/LoginContext";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import CustomAlert from "components/CustomAlert/CustomAlert";
import { configUrl, trialUserDuration } from "config";
import useCreateProvider from "hooks/providerHooks/useCreateProvider";
import {
  providerEmailExists,
  providerMobileExists
} from "hooks/providerHooks/useGetAllProvider";
import useCreateApplicationUser from "hooks/userHooks/useCreateApplicationUser";
import useCreateUser from "hooks/userHooks/useCreateUser";
import useGetUserByUserName from "hooks/userHooks/useGetUserByUserName";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ForgotPassService from "services/ForgotPassService";
import userService from "services/userService";

const useStyles = makeStyles(styles);

function Login(props) {
  const location = useLocation();
  const { hash, pathname, search } = location;
  const [loginUsername, setLoginUsername] = React.useState("");
  const [forgotEmail, setEmailForForgot] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const [showAlert1, setShowAlert1] = React.useState(false)
  const [severty, setSeverty] = React.useState('success');
  const [alertMessage, setAlertMessage] = React.useState('')
  const [intialLoad, setInitialLoad] = React.useState(true);
  const [Loading, setLoading] = React.useState(false);

  const [signIn, setSignIn] = React.useState(pathname == "/auth/signUp" ? 2 : 1);
  const [checkMandatory, setCheckMandatory] = React.useState(false);

  const [otpSent, setOtpSent] = useState(false);
  const [otpSending, setOtpSending] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otp, setOtp] = useState();
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [timer, setTimer] = useState(300); // 5 minutes

  const [showPassword, setShowPassword] = useState(false);

  const [firstNameState, setFirstNameState] = useState("Success");
  const [lastNameState, setLastNameState] = useState("Success");
  const [emailState, setEmailState] = useState("Success");
  const [passwordState, setPasswordState] = useState("Success");
  const [mobileState, setMobileState] = useState("Success");
  const [confirmPasscodeState, setConformPasscodeState] = React.useState("");
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [isProviderExistMobile, setIsProviderExistMobile] = React.useState(
    false
  );
  const {
    data: loginDetails,
    isLoading,
    mutate: getUserDetails,
    error: userFetchError,
  } = useGetUserByUserName();
  const { data: createproviderResponse, mutate: createprovider, isLoading: isLoadingCreation, isError, isSuccess } = useCreateProvider();

  const createUser = useCreateUser();
  const createUserRole = useCreateApplicationUser();
  const flipSignIn = (val) => {
    setSignIn(val);
  };

  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const { setUser, setUserId, setUserPrivileges, setProviderId, setProviderType, setUserType, setShowTrialAlert, setProviderValidTo, setContentProviderIds, setLicensePackageObject } = useContext(LoginContext);

  const [loginPassword, setLoginPassword] = React.useState("");
  const [retry, setRetry] = React.useState(true);
  const [userExists, setUserExists] = React.useState(false);

  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");

  const [mobile, setMobile] = React.useState(null);
  const [email, setEmail] = React.useState("");

  const [passwordSame, setPasswordSame] = React.useState(true);

  const [rePassWord, setRePassWord] = React.useState("");

  const [topics, setTopics] = React.useState(null);
  const validFrom = new Date();
  const validTo = new Date(validFrom); // clone it
  validTo.setDate(validFrom.getDate() + trialUserDuration);
  const [providerData, setProviderData] = useState({
    provider: {
      providerId: 0,
      name: null,
      providerTypeId: 3,
      packageId: 4,   //  PackageId for creating trial user
      logo: "",
      website: "",
      address: "",
      mobile: null,
      phone: "",
      email: null,
      gstInPercentage: 0,
      ParentProviderId: 0,
      detailedName: "",
      gstNumber: "",
      isActive: true,
      validFrom: validFrom,
      validTo: validTo,     // three days after valid from 
      createdDate: new Date(),
      updatedDate: new Date(),
      createdBy: "System",
      updatedBy: "System"
    },
    contentsCurator: [1],
  });

  const checkIfUserNameExists = (val) => {
    if (!val.target.value) {
      return;
    }

    getUserDetails(val.target.value);
  };

  React.useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });
  const classes = useStyles();

  const handleInputChange = (e) => {
    setLoginUsername(e.target.value);
    providerData.provider.userName = e.target.value;
  };
  const handleEmailInputChange = (e) => {
    setEmailForForgot(e.target.value)
  }
  const handlePasswordChange = (e) => {
    setLoginPassword(e.target.value);
    //providerData.provider.passCode = e.target.value;
  };

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
    providerData.provider.name = e.target.value + " " + lastName;
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
    providerData.provider.name = firstName + " " + e.target.value;
  };

  const handleMobileChange = (e) => {
    setMobile(e.target.value);
    providerData.provider.mobile = e.target.value;
  };

  React.useEffect(() => {

    const checkExistence = async () => {
      try {
        const temp = await providerEmailExists(email, 0);
        setUserExists(temp);
      } catch (error) {
        console.log(error);
      }
    };
    if (signIn == 2) {
      checkExistence();
    }
  }, [email]);

  React.useEffect(() => {
    const checkExistence = async () => {
      try {
        const temp = await providerMobileExists(mobile, 0);
        setIsProviderExistMobile(temp);
      } catch (error) {
        console.log(error);
      }
    };
    if (signIn == 2) {
      checkExistence();
    }
  }, [mobile]);

  const handleEmailChange = (e) => {
    setLoginUsername(e.target.value);
    providerData.provider.userName = e.target.value;
    setEmail(e.target.value);
    providerData.provider.email = e.target.value;

  };

  const handleRePasswordChange = (e) => {
    setRePassWord(e);
  };

  React.useEffect(() => {
    setInitialLoad(false);
  }, []);
  // const findPrivilege = async (userId) => {
  //   const Privilege = await getPrivileges.getPrivileges(userId)
  //   setUserPrivileges(Privilege);
  // }

  const convertToLocalTime = (utcDateTime, endOfDay = false) => {
    const date = new Date(utcDateTime);
    const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));

    if (endOfDay) {
      localDate.setHours(23, 59, 59, 999);
    } else {
      localDate.setHours(0, 0, 0, 0);
    }
    console.log(localDate, 'localDates')
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    const seconds = String(localDate.getSeconds()).padStart(2, '0');
    const milliseconds = String(localDate.getMilliseconds()).padStart(3, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }
  const adjustValidFrom = (utcDateTime) => {
    const date = new Date(utcDateTime);
    date.setDate(date.getDate() - 1); // Move one day before
    return convertToLocalTime(date, true); // End of the previous day
  }

  const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };
  const verifyMobileLength = (value, length) => /^\d+$/.test(value) && value.length == length;

  const verifyPassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    return regex.test(password);
  };
  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword((prevShowConfirmPassword) => !prevShowConfirmPassword);
  };
  const toggleShowPassword = () => setShowPassword(!showPassword);

  const verifyConfirmedPassword = (password, confirmPassword) => {
    return password === confirmPassword;
  };
  const getCurrentDateTimeFormatted = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
    return `${year}-${month}-${day}T00:00:00.00Z`;
  }


  // Example usage:
  const currentDateTime = getCurrentDateTimeFormatted();
  React.useEffect(async () => {

    if (!loginDetails?.userDetails) {
      return;
    }

    // if (signIn == 2) {
    //   console.log("checking user");
    //   if (loginDetails?.userDetails && loginDetails?.userDetails.userName) {
    //     setUserExists(true);
    //   } else {
    //     setUserExists(false);
    //   }

    //   return;
    // }
    // console.log(loginDetails, 'userDetails123');

    const validFromLocal = convertToLocalTime(loginDetails?.userDetails.validFrom, false);
    const validToLocal = convertToLocalTime(loginDetails?.userDetails.validTo, false);
    const now = getCurrentDateTimeFormatted();
    let privileges = loginDetails?.privilegeObject ? JSON.parse(loginDetails?.privilegeObject) : "";

    if (new Date(now) >= new Date(validFromLocal) && new Date(now) <= new Date(validToLocal)) {
      console.log('is inactive acc1.', now, 'From', validFromLocal, 'To', validToLocal)
      console.log('is inactive acc.', new Date(now), 'From', new Date(validFromLocal), 'To', new Date(validToLocal))
      console.log(new Date(now) >= new Date(validFromLocal), 'xx', new Date(now) <= new Date(validToLocal), 'case')
      if (
        loginDetails?.userDetails &&
        loginDetails?.userDetails.userName.toLowerCase() == loginUsername.toLowerCase() &&
        loginDetails?.userDetails.passCode == loginPassword
      ) {
        //
        //findPrivilege(loginDetails?.userDetails?.userId);
        // let privileges = loginDetails?.privilegeObject ? JSON.parse(loginDetails?.privilegeObject) : "";
        let licensePackage = loginDetails?.licenseObject ? JSON.parse(loginDetails?.licenseObject) : "";
        setLicensePackageObject(licensePackage);
        setUserPrivileges(privileges?.Value);
        setUser(loginUsername);
        setUserId(loginDetails?.userDetails?.userId);
        setProviderId(loginDetails?.userDetails.providerId);
        setProviderType(loginDetails?.userDetails.providerTypeId);
        setContentProviderIds(loginDetails?.userDetails.contentProviderIds["$values"]);
        setUserType(loginDetails?.userDetails.userTypeId);
        // for displaying alert only for trial user.
        setShowTrialAlert(privileges?.Value?.PackageId === 4);
        setProviderValidTo(loginDetails?.userDetails?.validTo)
        axios.defaults.headers.common = {
          providerId: loginDetails?.userDetails.providerId,
          contentProviderIds: loginDetails?.userDetails.contentProviderIds["$values"]
        };
        userService.updateLoginDate(loginDetails?.userDetails?.userId);
        props.history.push("/admin");
      } else {
        console.log('is invalid acc.')
        setRetry(false);
        setShowAlert(true);
      }
    } else {
      console.log('is inactive acc1.', now, 'From', validFromLocal, 'To', validToLocal)
      console.log('is inactive acc.', new Date(now), 'From', new Date(validFromLocal), 'To', new Date(validToLocal))
      console.log(new Date(now) >= new Date(validFromLocal), 'xx', new Date(now) <= new Date(validToLocal), 'case')
      setAlertMessage(privileges?.Value?.PackageId === 4 ? "Your trial has ended. Upgrade now to unlock full features!" : "User account is not active.");
      setSeverty('error');
      setShowAlert1(true);

    }
  }, [loginDetails]);

  useEffect(() => {
    let countdown;
    if (otpSent && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [otpSent, timer]);

  const sendOtp = async () => {
    if (email == "") {
      setAlertMessage("Please enter the email.");
      setSeverty('error');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
      return;
    }

    setOtpSending(true);
    try {
      await axios.post(`${configUrl.AssessmentServer}/api/Payments/sendotp/${email}`);
      setTimer(300);
      setOtpSent(true);
      setAlertMessage("OTP sent to your email.");
      setSeverty('success');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
    } catch (error) {
      setAlertMessage("Error sending OTP.");
      setSeverty('error');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
    } finally {
      setOtpSending(false);
    }
  };

  const verifyOtp = async () => {
    if (otp == "") {
      setAlertMessage("Please enter the OTP.");
      setSeverty('error');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
      return;
    }

    setOtpLoading(true);
    const request = {
      email: email,
      otp: otp,
    }
    try {
      const response = await axios.post(`${configUrl.AssessmentServer}/api/Payments/verifyotp`, request);

      if (response?.data?.verified) {
        setIsEmailVerified(true);
        setOtpSent(false);
        setAlertMessage("Email verified successfully.");
        setSeverty('success');
        setShowAlert1(true);
        setTimeout(() => {
          setShowAlert1(false);
        }, 2000);
      } else {
        setAlertMessage("Invalid OTP.");
        setSeverty('error');
        setShowAlert1(true);
        setTimeout(() => {
          setShowAlert1(false);
        }, 2000);
      }
    } catch (error) {
      setAlertMessage("Error verifying OTP.");
      setSeverty('error');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
    } finally {
      setOtpLoading(false);
    }
  };



  React.useEffect(() => {
    if (userFetchError && signIn == 1) {
      console.log("in here");
      setShowAlert(true);
    }
    if (userFetchError && signIn == 2) {
      setUserExists(false);
    }
  }, [userFetchError]);

  const handleSubmit = async () => {
    if (!loginUsername) {
      return;
    }

    getUserDetails(loginUsername);
    //setRetry(true);
  };
  const handleResetPass = async () => {
    if (!forgotEmail) {
      return;
    }
    // axios.defaults.headers.common = {
    //   providerId: 1000,
    // };
    try {
      setLoading(true);
      let emailResp = await ForgotPassService.EmailForForgotPass(forgotEmail)
      setLoading(false);
      console.log(emailResp, 'emailResp')
      if (emailResp.status == 200) {
        setAlertMessage('Email send successfully!')
        setSeverty('success');
        setShowAlert1(true);

        setTimeout(() => {
          setShowAlert1(false);
          flipSignIn(1);
        }, 3000);
      } else {
        setAlertMessage(emailResp.messege)
        setSeverty('error');
        setShowAlert1(true);
        setTimeout(() => {
          setShowAlert1(false);
        }, 3000);
      }
    } catch (error) {
      console.log(error, 'this is error')
      setAlertMessage('Error occured')
      setSeverty('error');
      setShowAlert1(true);
      setLoading(false);
    } finally {

      setLoading(false);
    }
    // getUserDetails(loginUsername);
    //setRetry(true);
  };
  const handleCreateUser = () => {
    if (isEmailVerified == false) {
      setAlertMessage("Please verify the email.")
      setSeverty('warning');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
      return;
    }
    if (userExists == true) {
      setAlertMessage("Email already exist.")
      setSeverty('warning');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
      return;
    }
    if (isProviderExistMobile == true) {
      setAlertMessage("Mobile already exist.")
      setSeverty('warning');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
      return;
    }
    if (lastName == "") {
      setLastNameState("error");
    }
    if (firstName == "") {
      setFirstNameState("error");
    }
    console.log("data si : ", firstName,
      loginUsername,
      lastName,
      mobile,
      email,
      loginPassword,
      rePassWord,
      firstNameState,
      lastNameState,
      mobileState,
      emailState);
    if (
      firstName == "" ||
      loginUsername == "" ||
      lastName == "" ||
      mobile == "" ||
      email == "" ||
      loginPassword == "" ||
      rePassWord == "" ||
      firstNameState == "error" ||
      lastNameState == "error" ||
      mobileState == "error" ||
      emailState == "error"
    ) {
      setCheckMandatory(true);
      setAlertMessage("Please fill all the fields.")
      setSeverty('warning');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
      return;
    }

    console.log(" provider creation data", providerData);

    // Call createprovider and handle response properly
    createprovider(providerData, {
      onSuccess: (createproviderResponse) => {
        console.log("Provider created:", createproviderResponse);

        const ProviderId = createproviderResponse?.providerId;
        const ProviderKey = createproviderResponse?.providerKey;

        if (!ProviderId) {
          console.log("No provider created");
          return;
        }

        // Now prepare user data
        const userDataObj = {
          users: {
            firstName,
            lastName,
            middleName: "",
            mobile,
            email,
            address: " ",
            providerId: ProviderId,
            userName: email,
            passCode: loginPassword,
            userTypeId: 2,
            isActive: true,
            createdBy: "System",
            updatedBy: "System",
          },
          prevSelectedId: 11, // roleId 11 for trial user
        };

        console.log(userDataObj, 'userDataObj to create user role');

        // Now create user role
        createUserRole.mutate(userDataObj);

        // (Optional) After creating user, you can also create the user record
        // createUser.mutate({
        //   userName: loginUsername,
        //   firstName,
        //   lastName,
        //   middleName: " ",
        //   mobile,
        //   email,
        //   passCode: loginPassword,
        //   address: " ",
        //   isActive: true,
        //   userTypeId: 2,
        // });
      },
      onError: (error) => {
        console.error("Error creating provider:", error);
      }
    });
  };

  React.useEffect(() => {
    if (createUserRole?.isSuccess == true) {
      console.log("user created", createUserRole);
      setAlertMessage("User created successfully.")
      setSeverty('success');
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
      }, 2000);
      //flipSignIn(1);
      getUserDetails(loginUsername);
      //props.history.push("/admin");
    }
  }, [createUserRole?.isSuccess]);

  React.useEffect(() => {
    if (createUserRole?.error == true) {
      setShowAlert(true);
    }
  }, [createUserRole?.error]);

  const [passwordType, setPasswordType] = React.useState("password");
  // const [passwordCo, setPasswordType] = React.useState("password");
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text")
      return;
    }
    else {
      setPasswordType("password")
      return;
    }
  }
  return (
    <div className={classes.container}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={6} md={4}>
          {signIn == 1 ? (
            <form onSubmit={handleSubmit} autoComplete="off">
              <Card login className={classes[cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="info"
                >
                  <h4 className={classes.cardTitle}>Log in</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="UserName"
                    id="userName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Face className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      autoComplete: "off",
                      onChange: handleInputChange,
                    }}
                  />

                  <CustomInput
                    labelText="Password"
                    id="password"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}
                            onClick={togglePassword}>
                            {passwordType === "password" ? <VisibilityOff /> : <Visibility />}
                          </Icon>
                        </InputAdornment>
                      ),
                      type: passwordType,
                      autoComplete: "off",
                      onChange: handlePasswordChange,
                    }}
                  />
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  {isLoading == true ? (
                    <CircularProgress
                      color="#00acc1"
                      style={{ size: "1.5rem" }}
                    />
                  ) : (
                    <Button
                      color="info"
                      size="md"
                      onClick={handleSubmit}
                      style={{ textTransform: 'none' }}
                    >
                      Log in
                    </Button>
                  )}
                </CardFooter>
                <CardFooter
                  className={classes.justifyContentCenter}
                  style={{ textTransform: "none" }}
                >
                  <a href="#" onClick={() => flipSignIn(3)} style={{ color: "#00acc1" }}> Forgot Password ?</a>
                </CardFooter>
                {/*   <CardFooter
                  className={classes.justifyContentCenter}
                  style={{ textTransform: "none" }}
                >
                  Don't have an account &nbsp;{" "}
                  <a href="#" onClick={() => flipSignIn(2)} style={{ color: "#00acc1" }}>
                    {" "}
                    Sign Up
                  </a>
                </CardFooter>
                */}
              </Card>
            </form>
          ) : signIn == 2 ? (
            <form onSubmit={handleSubmit} autoComplete="off">
              <Card
                login
                className={classes[cardAnimaton]}
                style={{ width: 500 }}
              >
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="info"
                >
                  <h4 className={classes.cardTitle} >Register</h4>
                </CardHeader>
                <CardBody>
                  {/* <CustomInput
                    labelText="User Name"
                    id="userName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    required={true}
                    error={userExists || (checkMandatory && !loginUsername)}
                    helperText={userExists == true ? "User Name Exists" : ""}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Face className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      autoComplete: "off",
                      onChange: handleInputChange,
                      onBlur: (v) => checkIfUserNameExists(v),
                    }}
                  /> */}

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="First Name"
                        id="userName"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        required={true}
                        error={firstNameState == "error"}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {/* <Face className={classes.inputAdornmentIcon} /> */}
                            </InputAdornment>
                          ),
                          autoComplete: "off",
                          onChange: (event) => {
                            if (firstName != "") {
                              setFirstNameState("success");
                            }
                            handleFirstNameChange(event);
                          },
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      {" "}
                      <CustomInput
                        labelText="Last Name"
                        id="userName"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        required={true}
                        error={lastNameState == "error"}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {/* <Face className={classes.inputAdornmentIcon} /> */}
                            </InputAdornment>
                          ),
                          autoComplete: "off",
                          onChange: (event) => {
                            if (lastName != "") {
                              setLastNameState("success");
                            }
                            handleLastNameChange(event);
                          },
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    {/* Email + Verify Button in one row */}
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer alignItems="center">
                        <GridItem xs={9}>
                          <CustomInput
                            success={emailState === "success"}
                            error={emailState === "error"}
                            labelText="Email"
                            id="email"
                            disabled={isEmailVerified == true}
                            formControlProps={{
                              fullWidth: true,
                            }}
                            required={true}
                            inputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  {/* <EmailIcon className={classes.inputAdornmentIcon} /> */}
                                </InputAdornment>
                              ),
                              autoComplete: "off",
                              type: "email",
                              onChange: (event) => {
                                if (!verifyEmail(event.target.value)) {
                                  setEmailState("error");
                                } else {
                                  setEmailState("success");
                                }
                                handleEmailChange(event);
                              },
                            }}
                          />
                        </GridItem>

                        <GridItem xs={3} style={{ display: "flex", alignItems: "center", marginTop: "3px" }}>
                          {otpSent > 0 ? (timer > 0 ? (
                            <p style={{ marginTop: "5px", fontSize: 10 }}>
                              {`Resend OTP in ${Math.floor(timer / 60)}:${String(timer % 60).padStart(2, "0")}`}
                            </p>
                          ) : (
                            <Button
                              color="info"
                              simple
                              size="sm"
                              onClick={sendOtp}
                              style={{ marginLeft: "1px", textTransform: "none" }}
                            >
                              {otpSending ? "sending..." : "Resend"}
                            </Button>
                          )) :
                            (!isEmailVerified ? (
                              <Button
                                color="info"
                                simple
                                size="sm"
                                onClick={sendOtp}
                                style={{ marginLeft: "1px", textTransform: "none" }}
                              >
                                {otpSending ? "sending..." : "Verify"}
                              </Button>
                            ) : (
                              <p style={{ color: "green", marginLeft: "1px", marginTop: "5px" }}>
                                ✅ Verified
                              </p>
                            ))}
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>

                  {/* OTP Section */}
                  {otpSent && !isEmailVerified && (
                    <GridContainer style={{ marginTop: "1px" }}>
                      <GridItem xs={12} sm={12} md={6}>
                        <GridContainer alignItems="center">
                          <GridItem xs={8}>
                            <CustomInput
                              labelText="Enter OTP"
                              id="otp"
                              formControlProps={{
                                fullWidth: true,
                              }}
                              inputProps={{
                                type: "text",
                                onChange: (e) => setOtp(e.target.value),
                              }}
                            />
                          </GridItem>

                          <GridItem xs={3} style={{ display: "flex", alignItems: "center", marginTop: "8px" }}>
                            <Button
                              color="info"
                              simple
                              size="sm"
                              onClick={verifyOtp}
                              style={{ marginRight: "10px", textTransform: "none" }}
                            >
                              {otpLoading ? "verifying..." : "Submit"}
                            </Button>
                          </GridItem>
                        </GridContainer>
                      </GridItem>
                    </GridContainer>
                  )}


                  <CustomInput
                    success={mobileState === "success"}
                    error={mobileState === "error"}
                    labelText="Mobile"
                    id="userName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    required={true}
                    inputProps={{
                      name: "mobile",
                      // value: user.mobile,
                      value: mobile,

                      onChange: (event) => {
                        if (!verifyMobileLength(event.target.value, 10)) {
                          setMobileState("error");
                        } else {
                          setMobileState("success");
                        }
                        handleMobileChange(event);
                      },
                    }}
                  />
                  <CustomInput
                    success={passwordState === "success"}
                    error={passwordState === "error"}
                    labelText="Password"
                    id="password"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    required={true}
                    inputProps={{
                      name: "passCode",
                      value: loginPassword,
                      type: showPassword ? "text" : "password",
                      onChange: (event) => {
                        if (!verifyPassword(event.target.value)) {
                          setPasswordState("error");
                        } else {
                          setPasswordState("success");
                        }
                        handlePasswordChange(event);
                      },
                      endAdornment: (
                        <InputAdornment position="end" >
                          <IconButton onClick={toggleShowPassword}>
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    helperText={passwordState ? "Password must include special characters,uppercase and lowercase letters,number and meet required length." : ''}

                  />

                  <CustomInput
                    success={rePassWord != "" && (loginPassword?.trim().length > 0 ?? loginPassword == rePassWord)}
                    error={confirmPasscodeState == "error"}
                    labelText="Confirm Password"
                    id="password"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    required={true}
                    helperText={confirmPasscodeState == "error" ? "The confirmed password does not match the original." : ''}
                    inputProps={{
                      type: showConfirmPassword ? 'text' : 'password',
                      onChange: (event) => {
                        if (!verifyConfirmedPassword(event.target.value, loginPassword)) {
                          setConformPasscodeState("error");
                        } else {
                          setConformPasscodeState("success");
                        }
                        handleRePasswordChange(event.target.value);
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={toggleShowConfirmPassword}>
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* <DropDownSelect setTopics={setTopics} showCategoriesOnly={true} /> */}
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  {(createUserRole?.isLoading == true || isLoadingCreation) ? (
                    <CircularProgress
                      color="#00acc1"
                      style={{ size: "1.5rem" }}
                    />
                  ) : (
                    <Button
                      color="info"
                      size="md"
                      disabled={isLoadingCreation || createUserRole?.isLoading}
                      onClick={handleCreateUser}
                      style={{ textTransform: 'none' }}
                    >
                      Create User
                    </Button>
                  )}
                </CardFooter>
                <CardFooter
                  className={classes.justifyContentCenter}
                  style={{ textTransform: "none" }}
                >
                  Already have an account &nbsp;{" "}
                  <a href="#" onClick={() => flipSignIn(1)} style={{ color: "#00acc1" }}>
                    {" "}
                    Sign In
                  </a>
                </CardFooter>
              </Card>
            </form>
          ) : (
            <form onSubmit={handleResetPass} autoComplete="off">
              <Card login className={classes[cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="info"
                >
                  <h4 className={classes.cardTitle}>Reset Password</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="Enter Email"
                    id="email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Face className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      autoComplete: "off",
                      onChange: handleEmailInputChange,
                    }}
                  />

                  {/* <CustomInput
                    labelText="Password"
                    id="password"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}
                            onClick={togglePassword}>
                            {passwordType === "password" ? <VisibilityOff /> : <Visibility />}
                          </Icon>
                        </InputAdornment>
                      ),
                      type: passwordType,
                      autoComplete: "off",
                      onChange: handlePasswordChange,
                    }}
                  /> */}
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  {Loading == true ? (
                    <CircularProgress
                      color="#00acc1"
                      style={{ size: "1.5rem" }}
                    />
                  ) : (
                    <Button
                      color="info"
                      size="lg"
                      onClick={handleResetPass}
                      style={{ textTransform: 'none' }}
                    >
                      Submit
                    </Button>
                  )}
                </CardFooter>
                <CardFooter
                  className={classes.justifyContentCenter}
                  style={{ textTransform: "none" }}
                >
                  Already have account &nbsp;{" "} <a href="#" onClick={() => flipSignIn(1)} style={{ color: "#00acc1" }}> Sign In</a>
                </CardFooter>
                <CardFooter
                  className={classes.justifyContentCenter}
                  style={{ textTransform: "none" }}
                >
                  Don't have an account &nbsp;{" "}
                  <a href="#" onClick={() => flipSignIn(2)} style={{ color: "#00acc1" }}>
                    {" "}
                    Sign Up
                  </a>
                </CardFooter>
              </Card>
            </form>
          )}
          <CustomAlert
            open={showAlert1}
            severity={severty}
            timeout={3000}
            alertMessage={alertMessage}
            handleClose={() => setShowAlert(false)}
          />
          <CustomAlert
            open={showAlert}
            severity="error"
            alertMessage={
              createUser.error == true
                ? "Unable to create user"
                : "Invalid Credentials"
            }
            handleClose={() => setShowAlert(false)}
          />
        </GridItem>
      </GridContainer>
    </div >
  );
}

export default withRouter(Login);
